import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import SoloView from '../component/SoloView'; 
import WxLoginButton from '../component/WxLoginButton'; 

@withRouter
@inject("store")
@observer
export default class Login extends Component
{
    // constructor(props) 
    // {
    //     super(props);
    // }
    
    // componentDidMount()
    // {
    //    // 
    // }

    render()
    {
        const main = <div className="flex flex-row pt-12 items-center justify-center"><WxLoginButton large={true}/></div>;
        return <SoloView title={this.props.store.appname} main={main} />;
    }
}